<div class="create-commercial-document">
  <h3 cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    @switch (data.type) {
      @case (cdProcessType.Agreement) {
        {{ 'CREATE_OF_AN_AGREEMENT' | translate }}
      }
      @case (cdProcessType.Order) {
        {{ 'CREATE_OF_AN_ORDER' | translate }}
      }
      @case (cdProcessType.Receipt) {
        {{ 'CREATION_OF_A_RECEIPT' | translate }}
      }
    }
  </h3>

  <form
    class="create-commercial-document__form"
    [formGroup]="form"
    (ngSubmit)="onCreate()">
    <div class="create-commercial-document__form-field">
      <mat-label class="create-commercial-document-matLabel">
        <div
          [ngClass]="[
            form.get('name')?.hasError('required') ? 'form-error' : 'form-valid'
          ]"></div>
        <span class="label-span">{{ 'NAME' | translate }}</span>
      </mat-label>

      <mat-form-field>
        <input matInput formControlName="name" maxlength="64" />
        <mat-error>{{ 'THIS_FIELD_IS_REQUIRED' | translate }}</mat-error>
      </mat-form-field>
    </div>

    <div class="create-commercial-document__row">
      <div class="create-commercial-document__form-field">
        <mat-label class="create-commercial-document-matLabel">
          <div
            [ngClass]="[
              form.get('orderSourceType')?.hasError('required') ||
              (!selectedRelatedDocument && isRelatedDocumentNeed)
                ? 'form-error'
                : 'form-valid'
            ]"></div>
          <span class="label-span">{{ 'SELECT_SOURCE' | translate }}</span>
        </mat-label>

        <mat-form-field>
          <mat-select
            formControlName="orderSourceType"
            placeholder="{{ 'SOURCE' | translate }}">
            @for (option of sourceOptions; track option) {
              <mat-option [value]="option.value"
                >{{ option.name | translate }}
              </mat-option>
            }
          </mat-select>
          <mat-error>{{ 'SELECTION_IS_REQUIRED' | translate }}</mat-error>
        </mat-form-field>
      </div>

      @if (isRelatedDocumentNeed) {
        <div class="create-commercial-document__form-field">
          <mat-label>
            <span class="label-span">{{ 'RELATED_DOCUMENT' | translate }}</span>
          </mat-label>
          <button
            mat-stroked-button
            type="button"
            [disabled]="!form.get('orderSourceType')?.value"
            (click)="openListModal()">
            {{ 'SELECT_DOCUMENT' | translate }}
          </button>
        </div>
      }
    </div>

    @if (selectedRelatedDocument) {
      <div class="create-commercial-document__current-document">
        <div class="create-commercial-document__current-document-item">
          <p>{{ 'NUMBER' | translate }}</p>
          <span>{{ selectedRelatedDocument.number }}</span>
        </div>
        <div class="create-commercial-document__current-document-item">
          <p>{{ 'NAME' | translate }}</p>
          <span>{{ selectedRelatedDocument.name }}</span>
        </div>
      </div>
    }

    <div class="create-commercial-document__type">
      <mat-label>
        <div
          [ngClass]="[
            form.get('procedureType')?.hasError('required') ||
            form.get('processTemplateId')?.hasError('required')
              ? 'form-error'
              : 'form-valid'
          ]"></div>
        <span class="label-span">{{
          'SELECT_THE_TYPE_OF_PROCEDURE' | translate
        }}</span>
      </mat-label>

      <mat-button-toggle-group formControlName="procedureType">
        @for (
          processTemplateGroup of processTemplateGroups;
          track processTemplateGroup.id
        ) {
          <mat-button-toggle [value]="processTemplateGroup"
            >{{ processTemplateGroup.name }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>

      @if (filteredProcessTemplates.length) {
        <mat-button-toggle-group
          formControlName="processTemplateId"
          class="create-commercial-document__process-templates">
          @for (template of filteredProcessTemplates; track template.id) {
            <mat-button-toggle [value]="template.id"
              >{{ template.name }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      }
    </div>

    @if (
      (form.get('procedureType')?.hasError('required') &&
        form.get('procedureType')?.touched) ||
      (form.get('processTemplateId')?.hasError('required') &&
        form.get('processTemplateId')?.touched)
    ) {
      <mat-error>{{ 'SELECTION_IS_REQUIRED' | translate }}</mat-error>
    }

    @if (this.data.type !== cdProcessType.Order) {
      <div class="create-commercial-document__form-field">
        <mat-label>
          <div
            [ngClass]="[
              form.get('commercialDocumentType')?.hasError('required')
                ? 'form-error'
                : 'form-valid'
            ]"></div>
          <span class="label-span">{{ 'TYPE_OF_AGREEMENT' | translate }}</span>
        </mat-label>
        <mat-button-toggle-group formControlName="commercialDocumentType">
          @for (
            commercialDocumentType of commercialDocumentTypes;
            track commercialDocumentType.id
          ) {
            <mat-button-toggle [value]="commercialDocumentType"
              >{{ commercialDocumentType.name }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
      @if (
        form.get('commercialDocumentType')?.hasError('required') &&
        form.get('commercialDocumentType')?.touched
      ) {
        <mat-error>{{ 'SELECTION_IS_REQUIRED' | translate }}</mat-error>
      }
    }
  </form>

  <div class="create-commercial-document-footer">
    <button mat-stroked-button type="button" (click)="onClose()">
      {{ 'CANCEL' | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="isCreateDisabled"
      (click)="onCreate()">
      {{ 'CREATE' | translate }}
    </button>
  </div>
</div>
